import { render, staticRenderFns } from "./ClaimLimitSetupGrid.vue?vue&type=template&id=0cc137a8"
import script from "./ClaimLimitSetupGrid.vue?vue&type=script&lang=js"
export * from "./ClaimLimitSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports